var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYardCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 38 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-yard-cover"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 20,
    x: 2,
    y: 2,
    rx: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-yard-cover)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2m12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3m-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6z",
    transform: "translate(-3 -8)scale(1.85)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 20,
    x: 2,
    y: 2,
    fill: "none",
    stroke: "currentColor",
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYardCover);
export default __webpack_public_path__ + "static/media/yard_cover.652607f61341b51213916c2c62158a04.svg";
export { ForwardRef as ReactComponent };